import CloseIcon from '@mui/icons-material/Close';
import { Alert, Grid2 as Grid, IconButton, Typography } from '@mui/material';
import React, { useMemo } from 'react';

import { IOneLinkErrors } from '../../../contexts/OneLinkSummaryProvider';

interface IProps {
  onClose: () => void;
  errors?: IOneLinkErrors;
}

export const AlertErrorBanner: React.FC<IProps> = ({ onClose, errors }) => {
  const errorMessages = useMemo(
    () =>
      Object.values(errors ?? {})
        .flatMap((fields: IOneLinkErrors[keyof IOneLinkErrors]) => Object.values(fields))
        // need to filter out the empty strings from the backend
        .filter((message) => message.length > 0),
    [errors],
  );

  return (
    <Grid sx={{ mb: 2 }}>
      <Alert
        severity="error"
        action={
          <IconButton size="small" onClick={onClose}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{ display: 'flex', alignItems: 'center' }}
      >
        <Typography component="span">
          Activation cannot be completed at this time. Please update the following:{' '}
          <Typography component="span" fontWeight="medium">
            {errorMessages.join(', ')}
          </Typography>
        </Typography>
      </Alert>
    </Grid>
  );
};
